import * as React from 'react';
import { ValueaditionNodeEdgeQuery } from './constants';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import { CompanyNodeEdge } from '../master/Company/constants';
import { BranchNodeEdge } from '../master/Branch/constants';
import { sumBy } from 'lodash';
import moment from 'moment';
import { JHARCRAFT_LOGO_URL, JHARKHAND_GOVT_LOGO_URL } from '../../config';

export const ValueaditionReceiptJharcraft: React.FunctionComponent<Props> = (
  props,
) => {
  const productDetailsEdges = props.valueadition.productDetails?.edges;
  const customers = props.valueadition;
  const totalQty = sumBy(
    productDetailsEdges,
    (value) => value.node.quantity || 0,
  );
  return (
    <Document>
      <Page size="A4" style={{ paddingBottom: 50 }}>
        <View fixed>
          <View style={[style.section, style.inline, { marginTop: 12 }]}>
            <Image
              style={[{ flex: 0.3, height: 43 }]}
              source={JHARCRAFT_LOGO_URL}
            />
            <Text
              style={[
                style.inlineHead,
                style.mediumBlackText,
                style.textCenter,
                { fontSize: '15.8pt', marginLeft: 15, marginRight: 15 },
              ]}
            >
              Jharkhand Silk, Textile &amp; Handicraft Development Corporation
              Ltd.
            </Text>
            <Image
              style={[{ flex: 0.15, height: 43 }]}
              source={JHARKHAND_GOVT_LOGO_URL}
            />
          </View>
          <View style={[style.section, { marginTop: 0 }]}>
            <Text
              style={[
                style.darkBlackText,
                style.textCenter,
                { fontSize: '13pt' },
              ]}
            >
              {props.branch.name}
            </Text>
          </View>
          <View style={[style.section, style.inline]}>
            <Text style={[style.inlineHeadDouble, style.lightBlackText]}>
              {props.branch.address}, Mo: {props.branch.contactNo}
            </Text>
            <Text
              style={[style.inlineHead, style.lightBlackText, { flex: 0.7 }]}
            >
              Helpline No: {props.company.contactNo}
            </Text>
            <Text style={[style.inlineHead, style.lightBlackText]}>
              Email: {props.branch.email}
            </Text>
            <Text
              style={[style.inlineHead, style.lightBlackText, { flex: 0.8 }]}
            >
              GSTIN: {props.branch.gstin}
            </Text>
          </View>
          <View style={style.divider} />
          <View style={style.section}>
            <Text
              style={[
                style.textCenter,
                style.mediumBlackText,
                { fontSize: '12pt' },
              ]}
            >
              Value Addition Challan
            </Text>
          </View>
          <View style={style.divider} />
          <View style={[style.section, style.inline]}>
            <Text style={[style.inlineHeadDouble, style.mediumBlackText]}>
              Invoice No:
              <Text style={[style.darkBlackText, style.textSpace]}>
                {`${props.valueadition.valueaditionNo}(${props.valueadition.branchSerialNo})`}
              </Text>
            </Text>
            <Text style={[style.lightBlackText, { flex: 0.5 }]}>
              Date: {moment(props.valueadition.date).format('DD-MM-YYYY')}
            </Text>
          </View>
          <View style={style.divider} />
        </View>
        <View>
          <View style={[style.section, style.inline]}>
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                { flex: 0.3 },
              ]}
            >
              Sl.
            </Text>
            <Text style={[style.highFlexInlineHead, style.mediumBlackText]}>
              Product
            </Text>
            {props.branch?.type === 'branch' && (
              <Text style={[style.inlineHead, style.mediumBlackText]}>
                Barcode
              </Text>
            )}
            {props.branch?.type === 'branch' && (
              <Text style={[style.lowFlexInlineHead, style.mediumBlackText]}>
                HSN Code
              </Text>
            )}
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                style.textRight,
                { flex: 0.4 },
              ]}
            >
              Qty
            </Text>
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                style.textRight,
                { flex: 0.4 },
              ]}
            >
              Value Addition Rate
            </Text>
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                style.textRight,
              ]}
            >
              Amount
            </Text>
          </View>
          <View style={style.divider} />
          {productDetailsEdges?.map((pd, i) => (
            <View
              style={[style.section, style.inline]}
              key={'pd' + i}
              wrap={false}
            >
              <Text
                style={[
                  style.lowFlexInlineHead,
                  style.lightBlackText,
                  { flex: 0.3 },
                ]}
              >
                {i + 1}.
              </Text>
              {props.branch?.type === 'branch' && (
                <Text style={[style.highFlexInlineHead, style.mediumBlackText]}>
                  {pd.node.product?.name}
                </Text>
              )}
              {props.branch?.type === 'company' && (
                <Text style={[style.highFlexInlineHead, style.mediumBlackText]}>
                  {pd.node.remark}
                </Text>
              )}
              {props.branch?.type === 'branch' && (
                <Text style={[style.inlineHead, style.mediumBlackText]}>
                  {pd.node.product?.oldBarcodeId}
                </Text>
              )}
              {props.branch?.type === 'branch' && (
                <Text style={[style.lowFlexInlineHead, style.mediumBlackText]}>
                  {pd.node.product?.hsn?.hsnCode}
                </Text>
              )}
              <Text
                style={[
                  style.lowFlexInlineHead,
                  style.mediumBlackText,
                  style.textRight,
                  { flex: 0.4 },
                ]}
              >
                {pd.node.quantity}
              </Text>
              <Text
                style={[
                  style.lowFlexInlineHead,
                  style.mediumBlackText,
                  style.textRight,
                  { flex: 0.4 },
                ]}
              >
                {pd.node.discount}
              </Text>
              <Text
                style={[
                  style.lowFlexInlineHead,
                  style.mediumBlackText,
                  style.textRight,
                ]}
              >
                {pd.node.amount?.toFixed(2)}
              </Text>
            </View>
          ))}
          <View style={style.divider} />
          <View style={[style.section, style.inline]}>
            <Text style={[style.highFlexInlineHead, style.darkBlackText]}>
              Grand Total:
            </Text>
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                { flex: 0.3 },
              ]}
            >
              {}
            </Text>
            <Text style={[style.inlineHead, style.mediumBlackText]}>{}</Text>
            <Text style={[style.lowFlexInlineHead, style.mediumBlackText]}>
              {}
            </Text>
            {props.branch?.type === 'branch' && (
              <Text
                style={[
                  style.lowFlexInlineHead,
                  style.mediumBlackText,
                  style.textRight,
                  { flex: 0.4 },
                ]}
              >
                {Number(totalQty).toFixed(2)}
              </Text>
            )}
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                { flex: 0.4 },
              ]}
            >
              {}
            </Text>
            <Text
              style={[
                style.lowFlexInlineHead,
                style.mediumBlackText,
                style.textRight,
              ]}
            >
              {Math.round(props.valueadition.totalMrp).toFixed(2)}
            </Text>
          </View>
          <View style={style.divider} />
          <View style={[style.section, style.inline]}>
            {customers.customer ? (
              <Text style={[style.darkBlackText, style.highFlexInlineHead]}>
                Customer:
                <Text style={style.textSpace}>
                  {customers.customer.name}
                  {customers.customer.contactNo
                    ? `(${customers.customer.contactNo})`
                    : ''}
                </Text>
              </Text>
            ) : (
              <Text style={[style.darkBlackText, style.highFlexInlineHead]}>
                Vendor:
                <Text style={style.textSpace}>
                  {customers.vendor.name}
                  {customers.vendor.contactNo
                    ? `(${customers.vendor.contactNo})`
                    : ''}{' '}
                </Text>
              </Text>
            )}
            <Text style={[style.textRight, style.darkBlackText, { flex: 0.5 }]}>
              Net Payable:
              <Text style={style.textSpace}>
                {Math.round(props.valueadition.totalMrp).toFixed(2)}
              </Text>
            </Text>
          </View>
          <View style={style.divider} />
          <View style={[style.section, style.inline]}>
            <Text style={[style.darkBlackText, style.highFlexInlineHead]}>
              Remark:
              <Text
                style={[
                  style.textSpace,
                  style.mediumBlackText,
                  style.lowFlexInlineHead,
                ]}
              >
                {props.valueadition.remark}
              </Text>
            </Text>
          </View>
          <View style={style.divider} />
          <View style={[style.section, { marginTop: 25 }]}>
            <Text style={[style.darkBlackText, style.textRight]}>
              Authority Sign
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const style = StyleSheet.create({
  section: { color: 'black', marginTop: 2, marginLeft: 15, marginRight: 15 },
  textCenter: { textAlign: 'center' },
  lightBlackText: { color: '#606060', fontSize: '7.4pt' },
  mediumBlackText: { color: '#282828', fontSize: '8.4pt' },
  darkBlackText: { color: '#000000', fontSize: '9.5pt' },
  divider: {
    border: 0,
    borderTop: '1pt solid black',
    height: '1pt',
    display: 'block',
  },
  box: { border: '1pt solid black' },
  inline: { flexDirection: 'row' },
  highFlexInlineHead: { flex: 1 },
  inlineHead: { flex: 1 },
  inlineHeadDouble: { flex: 1 },
  lowFlexInlineHead: { flex: 0.7 },
  textRight: { textAlign: 'right' },
  textLeft: { textAlign: 'left' },
  textJustify: { textAlign: 'justify' },
  textSpace: { marginLeft: 10 },
});

interface Props {
  valueadition: ValueaditionNodeEdgeQuery;
  company: CompanyNodeEdge;
  branch: BranchNodeEdge;
  selectedoption: 'CUSTOMER' | 'VENDOR';
}
